<template>
  <div class="flex flex-wrap col-12 white-bg border-box body-padding">
    <div class="flex col-12 h3">Sélectionnez votre créneau:</div>
    <div v-if="!loading && sessions.length" class="flex flex-wrap col-12 mt2 p2">
      <NewTDASession v-for="session in sessions" :key="session.code" :session="session" />
    </div>
    <div v-else-if="!loading" class="flex flex-wrap col-12 mt2 p2">
      <div class="flex col-12 h3">Aucun créneau disponible</div>
    </div>
  </div>
</template>

<script>
import NewTDASession from '@/components/sessions/NewTDASession.vue';

import { getAllSessions } from '@/utils/requests';

export default {
  components: { NewTDASession },
  data () {
    return {
      sessions: [],
      siteInfo: this.$store.state.siteInfo
    };
  },
  computed: {
    loading () {
      return this.$store.state.loading;
    }
  },
  async created () {
    this.$store.commit('setLoading', true);

    const response = await getAllSessions();

    if (response && response.success) {
      this.sessions = response.data;
    }

    this.$store.commit('setLoading', false);
  },
  methods: {}
};
</script>
